"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureSlot = exports.SlotType = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./SignatureSlot.css"));
var lodash_1 = require("lodash");
var Esign_1 = require("@CommonFrontend/AcceptFlow/ReactComponents/FormComponents/Esign");
var EmptySlot_1 = require("./EmptySlot");
var SignedSlotButton_1 = require("./SignedSlotButton");
var SignedSlot_1 = require("./SignedSlot");
var PrintableSlot_1 = require("./PrintableSlot");
var ModalContainer_css_1 = require("@CommonFrontend/Modal/ModalContainer.css");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var dynamic_1 = require("@vanilla-extract/dynamic");
var SlotType;
(function (SlotType) {
    SlotType["Signature"] = "Signature";
    SlotType["Initials"] = "Initials";
})(SlotType || (exports.SlotType = SlotType = {}));
var isBrowser = typeof window !== "undefined";
var SignatureSlot = function (_a) {
    var name = _a.name, data = _a.data, onChange = _a.onChange, onClear = _a.onClear, onFocus = _a.onFocus, onBlur = _a.onBlur, rawDateStamp = _a.dateStamp, isSlotFilledAnywhere = _a.isSlotFilledAnywhere, type = _a.type, isAccepted = _a.isAccepted, isEditable = _a.isEditable, isCritical = _a.isCritical, onSlotClick = _a.onSlotClick, _b = _a.labelStyle, labelStyle = _b === void 0 ? "field" : _b, _c = _a.isPrintMode, isPrintMode = _c === void 0 ? false : _c, _d = _a.isMultiAccept, isMultiAccept = _d === void 0 ? false : _d, _e = _a.hasPrefilledName, hasPrefilledName = _e === void 0 ? false : _e, _f = _a.alwaysHideName, alwaysHideName = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? "fit-content" : _g, _h = _a.zIndexStart, zIndexStart = _h === void 0 ? ModalContainer_css_1.modalZIndex : _h;
    var hasSignature = !!data;
    var _j = __read((0, react_1.useState)(null), 2), cachedSignature = _j[0], setCachedSignature = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), isSignaturePadOpen = _k[0], setIsSignaturePadOpen = _k[1];
    var _l = __read((0, react_1.useState)(false), 2), isMobile = _l[0], setIsMobile = _l[1];
    var dateStamp = rawDateStamp ? new Date(rawDateStamp).toLocaleDateString() : "";
    var doneButtonText = type === SlotType.Initials ? "Adopt and initial" : "Adopt and sign";
    (0, react_1.useEffect)(function () {
        if (isBrowser) {
            setIsMobile(window.innerWidth <= 767 || window.innerHeight <= 500);
            var handleResize_1 = function () {
                setIsMobile(window.innerWidth <= 767 || window.innerHeight <= 500);
            };
            window.addEventListener("resize", handleResize_1);
            return function () { return window.removeEventListener("resize", handleResize_1); };
        }
        return function () { };
    }, []);
    (0, react_1.useEffect)(function () {
        if (isBrowser && isMobile && isSignaturePadOpen) {
            document.body.style.overflow = "hidden";
            return function () {
                document.body.style.overflow = "";
            };
        }
        return function () { };
    }, [isMobile, isSignaturePadOpen]);
    (0, react_1.useEffect)(function () {
        if (isSignaturePadOpen) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        }
        else {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [isSignaturePadOpen, onBlur, onFocus]);
    var getSignatureContent = function (className) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", direction: "vertical", className: "".concat(className || styles.signatureContainer, " ").concat(styles.signatureContentStack) },
            react_1.default.createElement("div", { className: styles.signatureInputContainer },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", className: styles.signatureStackHeading },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", secondary: true, className: styles.signatureInputHeading },
                        "Adopt your ",
                        type.toLowerCase())),
                react_1.default.createElement(Esign_1.EsignComponent, { onFocus: lodash_1.noop, onBlur: lodash_1.noop, onChange: function (signature, method) { return setCachedSignature({ signature: signature, method: method }); }, isInitials: type === SlotType.Initials })),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "left" },
                "By selecting ",
                doneButtonText,
                ", I agree that my electronic ",
                type.toLowerCase(),
                type === SlotType.Initials ? "are" : "is",
                " as valid and legally binding as handwritten ",
                type.toLowerCase(),
                "."),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", gap: "s" },
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                        setCachedSignature(null);
                        setIsSignaturePadOpen(false);
                    }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Medium, className: styles.button({ disabled: !isEditable }) }, "Cancel"),
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                        if (cachedSignature) {
                            onChange(cachedSignature);
                        }
                        else {
                            onClear();
                        }
                        setIsSignaturePadOpen(false);
                    }, size: kaleidoscope_1.ButtonSize.Medium, className: styles.button({ disabled: !isEditable }) }, doneButtonText))));
    };
    if (isPrintMode) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center", className: "signature-slot-printable avoid-page-break" },
            react_1.default.createElement(PrintableSlot_1.PrintableSlot, { data: data, type: type, dateStamp: dateStamp, name: name, isMultiAccept: isMultiAccept, hasPrefilledName: hasPrefilledName, alwaysHideName: alwaysHideName })));
    }
    if (hasSignature && (isAccepted || !isEditable)) {
        return react_1.default.createElement(SignedSlot_1.SignedSlot, { data: data, type: type, dateStamp: dateStamp, labelStyle: labelStyle, name: name });
    }
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: zIndexStart + 1 }, function (_a) {
        var _b;
        var zIndex = _a.zIndex;
        return (react_1.default.createElement(kaleidoscope_1.Stack, { style: { zIndex: zIndex + 1 } },
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center" }, hasSignature ? (react_1.default.createElement(kaleidoscope_1.Layer, null, function () { return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { autoStack: true, button: react_1.default.createElement("div", { className: styles.signatureSlotWrapper },
                    react_1.default.createElement(SignedSlotButton_1.SignedSlotButton, { data: data, type: type, dateStamp: dateStamp, isCritical: isCritical, labelStyle: labelStyle, name: name, size: size })) },
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { closeOnClick: true, onClick: function () {
                        onClear();
                    } }, "Clear"),
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { closeOnClick: true, onClick: function () {
                        onClear();
                        setIsSignaturePadOpen(true);
                    } }, "Edit"))); })) : (react_1.default.createElement(react_1.default.Fragment, null, isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(EmptySlot_1.EmptySlot, { onClick: function () {
                        if (onSlotClick && isSlotFilledAnywhere) {
                            onSlotClick();
                        }
                        else {
                            setIsSignaturePadOpen(true);
                        }
                    }, onKeyDown: function (e) { return (e.key === "Enter" || e.key === " ") && setIsSignaturePadOpen(true); }, type: type, name: name, locked: !isEditable, isCritical: isCritical, isMultiAccept: isMultiAccept, hasPrefilledName: hasPrefilledName, alwaysHideName: alwaysHideName }),
                isSignaturePadOpen &&
                    (0, react_dom_1.createPortal)(react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { style: { zIndex: zIndex + 2 }, className: styles.overlay, onClick: function () { return setIsSignaturePadOpen(false); } }),
                        react_1.default.createElement("div", { style: (0, dynamic_1.assignInlineVars)((_b = {}, _b["--mobile-card-z-index"] = (zIndex + 2).toString(), _b)) },
                            react_1.default.createElement(kaleidoscope_1.Card, { className: styles.mobileCard }, getSignatureContent(styles.mobileSignatureContainer)))), (0, utils_1.getPortalRoot)("mobile-signature-bottom-sheet")))) : (react_1.default.createElement(kaleidoscope_1.Popover, { isOpen: isSignaturePadOpen, onChange: function (isOpen) {
                    if (isSlotFilledAnywhere)
                        return;
                    setIsSignaturePadOpen(isOpen);
                }, size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Right, autoStack: true, button: function (_a) {
                    var ref = _a.ref, buttonProps = __rest(_a, ["ref"]);
                    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)("signature-slot", styles.popoverButton) },
                        react_1.default.createElement(EmptySlot_1.EmptySlot, __assign({}, buttonProps, { onClick: function (e) {
                                if (buttonProps.onClick) {
                                    buttonProps.onClick(e);
                                }
                                if (onSlotClick && isSlotFilledAnywhere) {
                                    onSlotClick();
                                }
                            }, type: type, name: name, locked: !isEditable, isCritical: isCritical, isMultiAccept: isMultiAccept, hasPrefilledName: hasPrefilledName, alwaysHideName: alwaysHideName }))));
                } },
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", direction: "vertical", className: styles.signatureContainer },
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", className: styles.signatureStackHeading },
                        react_1.default.createElement(kaleidoscope_1.Heading, { "data-qwilr-id": "signature-slot-popover-heading", level: "4", secondary: true, className: styles.signatureInputHeading },
                            "Adopt your ",
                            type.toLowerCase())),
                    react_1.default.createElement(Esign_1.EsignComponent, { onFocus: lodash_1.noop, onBlur: lodash_1.noop, onChange: function (signature, method) { return setCachedSignature({ signature: signature, method: method }); }, isInitials: type === SlotType.Initials }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "left" },
                        "By selecting ",
                        doneButtonText,
                        ", I agree that my electronic ",
                        type.toLowerCase(),
                        " ",
                        type === SlotType.Initials ? "are" : "is",
                        " as valid and legally binding as handwritten",
                        " ",
                        type.toLowerCase(),
                        "."),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", gap: "s" },
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                setCachedSignature(null);
                                setIsSignaturePadOpen(false);
                            }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Medium, className: styles.button({ disabled: !isEditable }) }, "Cancel"),
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                if (cachedSignature) {
                                    onChange(cachedSignature);
                                }
                                else {
                                    onClear();
                                }
                                setIsSignaturePadOpen(false);
                            }, size: kaleidoscope_1.ButtonSize.Medium, className: styles.button({ disabled: !isEditable }) }, doneButtonText))))))))));
    }));
};
exports.SignatureSlot = SignatureSlot;
